import type { FeatureFlagGlobalUpdateRequestType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request } from "../apiV2Request";
import { trpc } from "../trpc";

export const useAdminFeatureFlagGloballyActiveUpdate = (
  featureFlagId: number,
) => {
  const queryClient = useQueryClient();
  const trpcUtils = trpc.useUtils();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (globallyActive: boolean | null) => {
      const data: FeatureFlagGlobalUpdateRequestType = { globallyActive };
      return apiV2Request({
        user,
        business,
        method: "patch",
        path: `feature-flags/${featureFlagId}/global`,
        data,
      });
    },
    onSuccess: () =>
      Promise.all([
        trpcUtils.featureFlag.list.invalidate(),
        queryClient.invalidateQueries({
          queryKey: ["feature-flags", "admin", business?.id],
        }),
      ]),
  });
};
